
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import CExportFile from '@/components/c-export-file'
import moment from 'moment'
import SetControlDialog from './components/dialog.vue'
import ImportDialog from './components/importDialog.vue'
import { getIndexConfig, getTableConfig, inputList, controlModeEnum } from './config'
import { usePagination } from '@/hooks/usePagination'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { dropdownOfEnterprise, getDeviceFactoryList, getDeviceMaintainList, getList, removeTerminal } from './api'
import { toResult } from '@/utils/toResult'

export default defineComponent({
  name: 'vehicle-device-management', // 车载设备管理
  components: {
    CSearchList,
    CTable,
    CExportFile,
    SetControlDialog,
    ImportDialog
  },
  setup() {
    const router = useRouter()

    // 企业名称远程搜索
    const remoteData1 = reactive({
      options: [] as any[],
      isLoading: false,
      remoteMethod: (val: string) => {
        dropdownOfEnterprise({ value: val }).then((res: any) => {
          remoteData1.options = (res.data || []).map((item: any) => {
            return {
              label: item.value,
              value: item.key
            }
          })
        })
      }
    })

    // 设备型号级联选择（厂商-型号懒加载）
    const cascaderProps = {
      lazy: true,
      emitPath: false,
      lazyLoad(node: any, resolve: any) {
        const { level, data } = node

        if (level === 0) {
          getDeviceFactoryList({}).then((res: any) => {
            const list = (res && res.data) || []
            resolve(
              list.map((i: any) => ({
                value: i.deviceFactoryUuid,
                label: i.deviceFactoryName,
                leaf: level >= 1
              }))
            )
          })
        }

        if (level === 1) {
          getDeviceMaintainList({ deviceFactoryUuid: data.value }).then(
            (res: any) => {
              const list = (res && res.data) || []
              resolve(
                list.map((i: any) => ({
                  value: i.deviceMaintainUuid,
                    label: i.deviceMaintainType,
                    leaf: level >= 1
                  }))
              )
            }
          )
        }
      }
    }

    const data = reactive({
      inputList: inputList({ ...toRefs(remoteData1) }),
      ...getIndexConfig()
    })

    const tableConfig = reactive({
      ...getTableConfig()
    })

    // 表格选中行
    const multipleSelection = ref([])
    const selectionChange = (selection: any[]): void => {
      multipleSelection.value = selection
    }

    // 设定管控弹窗选中的设备 ID
    const setModeIds = ref<number[]>([])

    // 代导入车载设备弹窗显隐
    const importVisible = ref(false)

    // 导出文件名：年月日-车载设备
    const exportFileName = `${moment().format('YYYYMMDD')}-车载设备`

    const getListFn = async () => {
      const p = {
        ...data.queryForm,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize
      }

      tableConfig.loading = true
      const [err, res] = await toResult(getList(p))
      tableConfig.loading = false
      if (err) return
      tableConfig.data = res.list || []
      tableConfig.pagination.total = res.total
    }

    // 查询
    const handleSearch = (params: object) => {
      tableConfig.pagination.currentPage = 1
      params && (data.queryForm = { ...params })
      getListFn()
    }

    // 重置
    const handleReset = (val: object) => {
      data.queryForm = val
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    // 移除设备
    const handleRemove = () => {
      ElMessageBox.confirm(
        '确认将选中的车辆控车设备从企业中删除？',
        '移除设备',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      )
        .then(() => {
          removeTerminal({
            ids: multipleSelection.value.map((item: any) => item.id)
          }).then((res: any) => {
            ElMessage.success(res.msg)
            getListFn()
          })
        })
        .catch(() => {})
    }

    const handleCommand = (command: string): void => {
      if (command === 'setMode') {
        setModeIds.value = multipleSelection.value.map((item: any) => item.id)
        data.visible = true
      }
      if (command === 'remove') {
        handleRemove()
      }
    }
    // 转移复制车载设备（跳转独立页面）
    const handleTransfer = (): void => {
      router.push({ name: 'vehicle-device-management-transfer' })
    }
    const handleImport = (): void => {
      importVisible.value = true
    }

    onMounted(() => {
      handleSearch({})
    })

    return {
      ...toRefs(data),
      controlModeEnum,
      cascaderProps,
      handleSearch,
      handleReset,
      tableConfig,
      pageCurrentChange,
      pageSizeChange,
      getListFn,
      handleCommand,
      handleTransfer,
      handleImport,
      exportFileName,
      multipleSelection,
      selectionChange,
      setModeIds,
      importVisible
    }
  }
})
